import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "error", "variant", "type", "value", "size", "onChange", "required", "label", "placeholder", "maxLength", "minLength", "maxValue", "inputProps", "changeTrigger"];
import TextField from "@mui/material/TextField";
import { useCallback, useEffect, useRef } from "react";
import { debounce } from "@mui/material";
import { FormItemTypes } from "../formBuilder/dynamicFormBuilder.entity";
export var FormTextInput = function (props) {
    var _a;
    var _b = props.name, name = _b === void 0 ? 'Name' : _b, _c = props.error, error = _c === void 0 ? null : _c, _d = props.variant, variant = _d === void 0 ? "outlined" : _d, _e = props.type, type = _e === void 0 ? "text" : _e, value = props.value, _f = props.size, size = _f === void 0 ? 'small' : _f, onChange = props.onChange, required = props.required, label = props.label, _g = props.placeholder, placeholder = _g === void 0 ? "Enter ".concat(label) : _g, maxLength = props.maxLength, minLength = props.minLength, maxValue = props.maxValue, inputProps = props.inputProps, _h = props.changeTrigger, changeTrigger = _h === void 0 ? 'onChange' : _h, others = _objectWithoutProperties(props, _excluded);
    var ref = useRef(null);
    var handleChange = useCallback(function (e) {
        e.stopPropagation();
        var input = e.target.value;
        onChange === null || onChange === void 0 || onChange(e, input);
    }, [value, onChange, maxValue, maxLength, minLength, ref.current]);
    var debouncedInputChange = useCallback(debounce(function (e) {
        var onChangeHandler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : handleChange;
        e.stopPropagation();
        onChangeHandler(e);
    }, 500), []);
    var onValueChange = function (e) {
        debouncedInputChange(e, handleChange);
    };
    useEffect(function () {
        var _ref$current;
        var prevInput = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.value;
        if (ref.current && value !== prevInput) {
            var newInput = value !== null && value !== void 0 ? value : '';
            ref.current.value = newInput;
        }
    }, [value]);
    var onInput = function (e) {
        e.stopPropagation();
        if (!ref.current)
            return;
        var inputType = e.nativeEvent.inputType;
        var input = e.target.value;
        if (input !== '' && type === 'number') {
            var num = Number(input);
            if (typeof maxValue === 'number' && num > maxValue) {
                if (inputType === 'insertFromPaste') {
                    ref.current.value = '';
                }
                ref.current.value = input.slice(0, -1);
                return;
            }
            if (maxLength && input.length > maxLength) {
                ref.current.value = input.slice(0, -1);
                return;
            }
        }
    };
    return /*#__PURE__*/ React.createElement(TextField, _extends({
        inputRef: ref,
        fullWidth: true,
        name: name,
        type: type === FormItemTypes.TextInput ? "text" : type,
        size: size,
        variant: variant,
        required: required,
        placeholder: placeholder
    }, others, (_a = {},
        _a[changeTrigger] = onValueChange,
        _a), error && {
        error: true,
        helperText: error
    }, {
        onInput: onInput,
        onWheel: function (e) {
            e.target.blur();
        }
    }));
};
